import VerticalStepsFcl from "./vertical-steps-fcl.component";

export default VerticalStepsFcl;
